export { default as reducer } from "./store.ducks";



// WEBPACK FOOTER //
// ./src/routes/Store/index.ts